export const blockHeight = 600;
export const blockWidth = 350;


export const addRmvAllBtnSize = 30;
export const addRmvAllBtnMargin = 10;
export const centering = (blockHeight/2) - (addRmvAllBtnSize + (addRmvAllBtnMargin*2));

export const addRmvBtnMarginLeft = 5;
export const addRmvBtnSize = 25;
export const clusterLabelPadding = 10;
export const clusterLabelWidth = blockWidth - 4;
export const scrollGap = 20;
// +10 to make a gap between button and text disappearance
export const clusterLabelTextWidth = blockWidth - (addRmvBtnMarginLeft + addRmvBtnSize + (clusterLabelPadding*2) + scrollGap + 10);

export const fullWidth = (blockWidth*2) + addRmvAllBtnSize + (addRmvAllBtnMargin*2)